import { useQuery } from '@tanstack/react-query'
import { Session, userPoints } from '../api'

export const useFetchUser = (session: Session | undefined) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['userData', session?.user?.id],
    queryFn: async () => {
      if (!session?.accessToken) {
        throw new Error('No session available')
      }
      if (!session.user.id) {
        throw new Error('No user ID available')
      }
      const response = await userPoints(session.user.id)
      return response?.data
    },
    // Only run the query if we have a session with an access token and user ID
    enabled: !!session?.accessToken && !!session?.user?.id,
    // Cache the data for 5 minutes
    staleTime: 5 * 60 * 1000
  })

  return {
    userData: data,
    isLoading,
    error
  }
}
